import axios from '../helpers/axios';
import { logError } from '../services';
import { IResponse, IUserJobTitle, IUserJobTitleQueryParams, IUserJobTitleCreate, IUserJobTitleUpdate } from '../models';

const baseUrl = '/api/jobtitle';

export const getJobTitles = async (filters?: IUserJobTitleQueryParams): Promise<IResponse<IUserJobTitle[]>> => {
  try {
    const { data } = await axios.get(baseUrl, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getJobTitles failed');
    return Promise.reject(error);
  }
};

export const getJobTitleDetails = async (userJobTitleId: number): Promise<IUserJobTitle> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${userJobTitleId}`);
    return data;
  } catch (error) {
    logError(error, 'getJobTitleDetails failed');
    return Promise.reject(error);
  }
};

export const createJobTitle = async (payload: IUserJobTitleCreate): Promise<IUserJobTitle> => {
  try {
    const { data } = await axios.post(baseUrl, payload);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload
      },
      'createJobTitle failed'
    );
    return Promise.reject(error);
  }
};

export const updateJobTitle = async (
  userJobTitleId: number,
  payload: IUserJobTitleUpdate
): Promise<IUserJobTitle> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${userJobTitleId}`, payload);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: { userJobTitleId, jobTitleDetails: payload }
      },
      'updateJobTitle failed'
    );
    return Promise.reject(error);
  }
};

export const deleteJobTitle = async (userJobTitleId: number | string): Promise<any> => {
  try {
    const { data } = await axios.delete(`${baseUrl}/${userJobTitleId}`);
    return data;
  } catch (error) {
    logError(error, 'deleteJobTitle failed');
    return Promise.reject(error);
  }
};

export const getJobTitlePartCategories = async (userJobTitleId: number): Promise<any> => {
  try {
    const { data } = await axios.get(`/api/jobtitle/${userJobTitleId}/part-categories`);
    return data;
  } catch (error) {
    logError(error, 'getJobTitlePartCategories failed');
    return Promise.reject(error);
  }
};
